export default __webpack_public_path__ + "static/media/cross.23fc7252.svg";